export const TIMESHEET_PROJECT_KEY = 'timesheetProject';
export const TIMESHEET_START_DATE_KEY = 'timesheetStartDate';
export const TIMESHEET_END_DATE_KEY = 'timesheetEndDate';
